import script from "./SensorMonitoring.vue?vue&type=script&lang=ts&setup=true"
export * from "./SensorMonitoring.vue?vue&type=script&lang=ts&setup=true"

import "./SensorMonitoring.vue?vue&type=style&index=0&id=e79c77da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e79c77da"]])

export default __exports__